import { Col, List } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { TaskRepresentation } from 'src/generated-api-client';
import { DateHelper } from 'src/utils/DateHelper';
import styled from 'styled-components';

export type AgentTaskListItemProps = {
    item: TaskRepresentation;
};

export const AgentTaskListItem = observer(
    ({ item, ...props }: AgentTaskListItemProps) => {
        const { t } = useTranslation();

        const hasL10nTitleKey = Boolean(item.extensions?.l10nTitleKey);
        const title = hasL10nTitleKey
            ? (t(`${item.extensions?.l10nTitleKey}`, {
                  ...item?.taskInfo,
              }) as string)
            : item.name;

        return (
            <StyledListItem
                {...props}
                data-testid={`master-details-list-item-${item.id}`}
            >
                <TaskStyledLink to={EntityLinks.tasks.itemDetails(item.id)}>
                    <LinkInnerContainer>
                        <StyledInfoCol flex={1} data-testid="task-info">
                            {title}
                        </StyledInfoCol>
                        <StyledDateCol data-testid="createTime">
                            {DateHelper.format(item.createTime)}
                        </StyledDateCol>
                    </LinkInnerContainer>
                </TaskStyledLink>
            </StyledListItem>
        );
    },
);

const StyledListItem = styled(List.Item)`
    position: relative;
    background: var(--background);
    color: var(--text-color);
`;

const StyledInfoCol = styled(Col)`
    width: 15rem;
    flex: initial !important;
    font-weight: 400;
    font-size: 1rem;
    line-height: 125%;
`;

const StyledDateCol = styled(Col)`
    font-size: 0.8rem;
    line-height: 150%;

    text-align: right;

    color: #828b94;
`;

const TaskStyledLink = styled(NavLink)`
    display: block;
    padding: 0.7rem 0.6rem;
    background: var(--aside-list-item-bg);
    font-size: 1.7rem;
    color: var(--text-color);
    border-radius: 0.75rem;

    &:hover {
        background: var(--background);
        border-color: var(--background);
        background: var(--aside-list-active-bg);
        color: var(--text-color);
        text-decoration: none;
    }

    &.active {
        background: var(--aside-list-active-bg);
        border-color: var(--aside-list-active-bg);
        color: var(--text-color);
    }
`;

const LinkInnerContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
